export default __webpack_public_path__ + "static/media/HEADER.b5a82144.jpg";